import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		inputBuildingAddressSummary_addressInfo: {
			display: 'flex',
			flexDirection: 'column',
			padding: theme.spacing(3, 0),
		},
		inputBuildingAddressSummary_addressLine: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h6.fontSize,
		},
		inputBuildingAddressSummary_addressInfoEditOptions: {
			marginTop: theme.spacing(1),
			display: 'flex',
			flexWrap: 'wrap',
		},
		inputBuildingAddressSummary_addressInfoEditOptionChangeAddress: {
			marginRight: theme.spacing(2),
			padding: theme.spacing(1, 0)
		},
		inputBuildingAddressSummary_addressInfoEditOptionChangeLocation: {
			padding: theme.spacing(1, 0,)
		},
		inputBuildingAddressSummary_helperText: {
			padding: theme.spacing(1, 0, 0, 0),
		},
		inputBuildingAddressSummary_labelWrapper: {
			'&:focus': {
				outline: `1px dotted ${theme.palette.grey[500]}`,
			}
		},
		inputBuildingAddressSummary_label: {
			padding: theme.spacing(0, 0, 1, 0),
		},
	});
});

export default useStyles;
